import React, { useEffect } from "react";
import { observer } from "mobx-react";

import { fn_change_df_time, fn_autoFlagConfirm, fn_change_auto_accept_flag } from "function/FnBodySetting";
import * as style from "./SettingDefaultOrderDirectView.styles";
import { Switcher } from "components/ui/Switcher";
import { SectionTitle } from "components/ui/SectionTitle";
import ConnectDlvAlertView from "./components/ConnectDlvAlertView";
import ProgramList from "./components/ProgramList";
import { overlay } from "overlay-kit";
import { CommonModal } from "components/modal/CommonModal";
import { ModalMessages } from "components/modal/constant/Modal";

interface SettingDefaultOrderDirectViewProps {
  rootStore: any;
}

const SettingDefaultOrderDirectView: React.FC<SettingDefaultOrderDirectViewProps> = observer(({ rootStore }) => {
  const { settingStore, searchStore } = rootStore;

  useEffect(() => {
    const list = settingStore.getSettingOutAutoProg;
    if (list) {
      const isAnyUsed = list.some((obj: any) => obj.configUseYn === "Y");
      settingStore.setSettingOutAuto(isAnyUsed);
    }
  }, [settingStore.getSettingOutAutoProg]);

  const getProgramAutoCompleteList = () => {
    const isBaeminUsedOnCurrentPos =
      settingStore.getBaeminUseStatus.isCurrentPosBaeminUse === "Y" &&
      searchStore.getSession.connPosNo === settingStore.getBaeminUseStatus.baeminUsePosNo;

    if (isBaeminUsedOnCurrentPos) {
      return settingStore.getSettingOutAutoProg.filter(
        (item: any) => item.configName !== "배달의민족" && item.configName !== "배민1"
      );
    }

    return settingStore.getSettingOutAutoProg;
  };

  const autoAcceptSwitcherClick = () => {
    if (settingStore.getAutoAcceptFlag === "N") {
      overlay.open(({ isOpen, close }) => (
        <CommonModal
          open={isOpen}
          onClose={close}
          modalMsg={ModalMessages.AUTO_ACCEPT_SWITCHER_ON}
          onConfirm={() => {
            fn_change_auto_accept_flag(rootStore, "Y");
            close();
          }}
          button2Variant="gray"
        />
      ));
    } else {
      overlay.open(({ isOpen, close }) => (
        <CommonModal
          open={isOpen}
          onClose={close}
          modalMsg={ModalMessages.AUTO_ACCEPT_SWITCHER_OFF}
          onConfirm={() => {
            fn_change_auto_accept_flag(rootStore, "N");
            close();
          }}
          button2Variant="gray"
        />
      ));
    }
  };

  return (
    <>
      <div className="scroll tab">
        <div className="inner">
          <div className="wrap_connect">
            <div className="box_cont flex flex-col gap-4">
              <SectionTitle title="연동 주문 - 접수시간 기본값" addBottomBorder />

              <ConnectDlvAlertView rootStore={rootStore} />

              {/* 배달 예상시간 */}
              <div className="setting" style={{ marginBottom: "0" }}>
                <style.Text size="20px" color="#323639" weight="700">
                  배달 예상시간
                </style.Text>
                <style.Text size="15px" color="#6B7884" weight="400">
                  배달 주문 접수시 기본 시간
                </style.Text>
                <div className="change" style={{ borderRadius: "1000px" }}>
                  <button
                    type="button"
                    className="btn_m"
                    disabled={settingStore.getDeliveryDfTime === "0"}
                    onClick={() => fn_change_df_time(rootStore, "delivery", "down")}
                  >
                    <span className={settingStore.getDeliveryDfTime === "0" ? "min_disabled" : ""}></span>
                  </button>
                  <strong>
                    {settingStore.getDeliveryDfTime === "0" ? "즉시" : `${settingStore.getDeliveryDfTime}분`}
                  </strong>
                  <button
                    type="button"
                    className="btn_p"
                    disabled={settingStore.getDeliveryDfTime === "120"}
                    onClick={() => fn_change_df_time(rootStore, "delivery", "up")}
                  >
                    <span className={settingStore.getDeliveryDfTime === "120" ? "max_disabled" : ""}></span>
                  </button>
                </div>
              </div>

              {/* 포장/매장 예상시간 */}
              <div className="setting" style={{ marginBottom: "0" }}>
                <style.Text size="20px" color="#323639" weight="700">
                  포장/매장 예상시간
                </style.Text>
                <style.Text size="15px" color="#6B7884" weight="400">
                  포장·매장 주문 접수시 기본 시간
                </style.Text>
                <div className="change" style={{ borderRadius: "1000px" }}>
                  <button
                    type="button"
                    className="btn_m"
                    disabled={settingStore.getCookingDfTime === "0"}
                    onClick={() => fn_change_df_time(rootStore, "cooking", "down")}
                  >
                    <span className={settingStore.getCookingDfTime === "0" ? "min_disabled" : ""}></span>
                  </button>
                  <strong>
                    {settingStore.getCookingDfTime === "0" ? "즉시" : `${settingStore.getCookingDfTime}분`}
                  </strong>
                  <button
                    type="button"
                    className="btn_p"
                    disabled={settingStore.getCookingDfTime === "120"}
                    onClick={() => fn_change_df_time(rootStore, "cooking", "up")}
                  >
                    <span className={settingStore.getCookingDfTime === "120" ? "max_disabled" : ""}></span>
                  </button>
                </div>
              </div>
            </div>

            <div className="box_cont flex flex-col gap-4" style={{ paddingTop: "72px", borderTop: "none" }}>
              <SectionTitle title="연동 주문 - 자동 접수 설정" addBottomBorder />

              <ConnectDlvAlertView rootStore={rootStore} />

              <style.FlexJustifyBetween>
                <div style={{ paddingLeft: "16px" }}>
                  <style.Text size="20px" color="#323639" weight="700">
                    자동 접수 사용
                  </style.Text>
                  <style.Text size="15px" color="#6B7884" weight="400">
                    {settingStore.getAutoAcceptFlag === "N"
                      ? "주문이 들어올 때마다 신규주문 알림팝업에서 접수처리 합니다"
                      : "상단에 설정한 [접수시간 기본값]으로 주문이 자동 접수처리 됩니다"}
                  </style.Text>
                </div>
                <Switcher
                  size="lg"
                  checked={settingStore.getAutoAcceptFlag === "Y"}
                  onChange={() => autoAcceptSwitcherClick()}
                  showLabel={true}
                  switcherColor="primary"
                  onLabel="사용"
                  offLabel="미사용"
                />
              </style.FlexJustifyBetween>
            </div>

            <div className="box_cont flex flex-col gap-4" style={{ paddingTop: "72px", borderTop: "none" }}>
              <div>
                <SectionTitle title="주문서 인식 주문 - 즉시 완료 설정" addBottomBorder>
                  <Switcher
                    size="lg"
                    id="checkbox1"
                    checked={settingStore.getSettingOutAuto}
                    onChange={() => fn_autoFlagConfirm(rootStore, "all")}
                    showLabel={true}
                    switcherColor="primary"
                    onLabel="사용"
                    offLabel="미사용"
                  />
                </SectionTitle>

                {settingStore.getSettingOutAuto ? (
                  <div className="box_list">
                    <p className="txt">
                      활성화 시, 주문이 접수되면 <strong>즉시 완료</strong>처리되므로
                      <br />
                      <strong>배달대행사 호출이 불가</strong>하며 <strong>주문현황 화면</strong>에서{" "}
                      <strong>확인할 수 없습니다.</strong>
                    </p>
                    <ProgramList list={getProgramAutoCompleteList()} rootStore={rootStore} />
                  </div>
                ) : (
                  <div className="box_info_img">
                    <div className="tit">
                      <strong>배달앱 매출을 편리하게 합산해 보세요</strong>
                    </div>
                    <p className="desc">
                      주문을 일일이 완료하지 않아도
                      <br />
                      <strong>배달앱 매출이 자동으로 합산</strong>되어서 편리해요!
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default SettingDefaultOrderDirectView;
